// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2722) return "static/chunks/2722-ed16c9ef6fa378e2.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"5e418f71f9ad5f8f","4478":"21fa16bcac8786fc","9177":"4b2889ee357f728a"}[chunkId] + ".js";
};